// @ts-nocheck
import { numberFormat } from './numbers'

export const monthNames = [
  '',
  'Januar',
  'Februar',
  'Mars',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Desember',
]

export function getMonthName(dateString) {
  let parts = dateString.split('T')
  let dateParts = parts[0].split('-')
  let year = dateParts[0]
  let month = parseInt(dateParts[1])
  return monthNames[month] + ' ' + year
}

export function getYearFromDateString(dateString) {
  let parts = dateString.split('T')
  let dateParts = parts[0].split('-')
  let year = dateParts[0]
  return year
}

export function dateToMonthName(dateString) {
  let parts = dateString.split('T')
  let dateParts = parts[0].split('-')
  let month = parseInt(dateParts[1])
  return monthNames[month]
}

export function secondsToHours(seconds) {
  let hours = Math.floor(seconds / 3600)
  let minutes = Math.floor((seconds - hours * 3600) / 60)
  let secs = seconds % 60
  if (hours < 10) hours = '0' + hours
  if (minutes < 10) minutes = '0' + minutes
  if (secs < 10) secs = '0' + secs
  return hours + ':' + minutes + ':' + secs
}

export function byteFormatter(bytes) {
  let KB = bytes / 1024
  let MB = KB / 1024
  let GB = MB / 1024
  if (GB > 0.5) {
    return numberFormat(GB, 2) + ' GB'
  } else if (MB > 0.5) {
    return numberFormat(MB, 2) + ' MB'
  } else {
    return numberFormat(KB, 2) + ' KB'
  }
}

export function pad(n) {
  return n < 10 ? '0' + n : n
}

// legacy code to be removed when the db has all dates in UTC
export function parseDate(myDate) {
  if (!myDate) return null

  let parts
  let date
  let time
  let dt

  parts = myDate.split(/[T ]/) // Split on `T` or a space to get date and time
  date = parts[0]
  time = parts[1]

  dt = new Date()

  parts = date.split(/[-/]/) // Split date on - or /
  dt.setFullYear(parseInt(parts[0], 10))
  dt.setMonth(parseInt(parts[1], 10) - 1) // Months start at 0 in JS
  dt.setDate(parseInt(parts[2], 10))

  parts = time.split(/:/) // Split time on :
  dt.setHours(parseInt(parts[0], 10))
  dt.setMinutes(parseInt(parts[1], 10))
  dt.setSeconds(parseInt(parts[2], 10))

  return dt
}

export function dateFormat(date: Date) {
  if (!date) return null
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  if (month < 10) month = '0' + month
  if (day < 10) day = '0' + day
  return day + '.' + month + '.' + year
}
